// extracted by mini-css-extract-plugin
export default {"yivi-web-form":"email_sent_yivi-web-form__eR6d6","yivi-web-content":"email_sent_yivi-web-content__7FqVy","center":"email_sent_center__hmomp"};